<template>
  <div class="moment">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/exhibition/index">推广</BreadcrumbItem>
          <BreadcrumbItem>供需</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.name}}</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="add()">
          <span class="htb-add">+</span>
          <span style="margin-left:5px;">发布供需</span>
        </div>
      </div>
    </div>
    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="全部" name="1">
          <exhibitionReleaseNewAll></exhibitionReleaseNewAll>
        </TabPane>
        <TabPane label="待审核" name="2">
          <exhibitionReleaseNewAwait></exhibitionReleaseNewAwait>
        </TabPane>
        <TabPane label="审核通过" name="3">
          <exhibitionReleaseNewPass></exhibitionReleaseNewPass>
        </TabPane>
        <TabPane label="审核未通过" name="4">
          <exhibitionReleaseNewReject></exhibitionReleaseNewReject>
        </TabPane>
      </Tabs>
    </div>
    <Contact />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Contact from "@components/Contact/Contact";
import exhibitionReleaseNewAll from "./components/exhibition-release-new-all";
import exhibitionReleaseNewAwait from "./components/exhibition-release-new-await";
import exhibitionReleaseNewPass from "./components/exhibition-release-new-pass";
import exhibitionReleaseNewReject from "./components/exhibition-release-new-reject";

export default {
  name: "exhibition-release-new",
  data() {
    return {
      showTabs: "1"
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      joinEx: "companyModule/getJoinEx",
      exhibition: "loginModule/getExhibition"
    }),
    query() {
      return this.$route.query;
    }
  },
  components: {
    Contact,
    exhibitionReleaseNewAll,
    exhibitionReleaseNewAwait,
    exhibitionReleaseNewPass,
    exhibitionReleaseNewReject
  },
  created() {
    const query = this.query;
    const type = query.type;
    if (query && type && type === "await") {
      this.showTabs = "2";
    } else if (query && type && type === "pass") {
      this.showTabs = "3";
    } else if (query && type && type === "reject") {
      this.showTabs = "4";
    }
  },
  methods: {
    ...mapActions({
      getRelease: "momentModule/getRelease",
      addRelease: "momentModule/addRelease",
      delRelease: "momentModule/delRelease",
      getWeAppSmallCode: "momentModule/getWeAppSmallCode",
      getReleaseType: "momentModule/getReleaseType"
    }),
    async init() {},
    switchBrand(name) {
      if (name === "1") {
        this.$router.push(`${this.$route.path}?type=all`);
      } else if (name === "2") {
        this.$router.push(`${this.$route.path}?type=await`);
      } else if (name === "3") {
        this.$router.push(`${this.$route.path}?type=pass`);
      } else if (name === "4") {
        this.$router.push(`${this.$route.path}?type=reject`);
      }
    },
    add() {}
  }
};
</script>

<style lang="scss" scoped>
.moment-content {
  min-width: 1000px;
  background-color: #fff;
  margin: 30px;
}
</style>